export const KEY_COLUMNS = ["Wins", "Performance Rating", "Win %", "Score Efficiency", "Net W-L"];
const norm = (s) => String(s ?? "").trim().toLowerCase();
const KEY_SET = new Set(KEY_COLUMNS.map(norm));

export const isKey = (col) => KEY_SET.has(norm(col));
export const isBlank = (v) => String(v ?? "").trim() === "";
export const sameName = (a, b) => norm(a) === norm(b);

export const toNum = (v) => {
  const s = String(v ?? "").replace(/[,%$]/g, "").trim();
  return s !== "" && !Number.isNaN(Number(s)) ? Number(s) : null;
};

export const playerColIndex = (columns) => {
  const i = columns.findIndex((c) => norm(c) === "player");
  return i >= 0 ? i : 0;
};

export const teamColIndex = (columns) => columns.findIndex((c) => norm(c).startsWith("team"));
export const appsColIndex = (columns) => columns.findIndex((c) => norm(c) === "appearances");

// Active minimum-appearances rule for a dataset (0 = none, or no Appearances column).
export const minApps = (dataset) => (dataset?.min_appearances > 0 && appsColIndex(dataset.columns || []) >= 0 ? dataset.min_appearances : 0);
export const qualifies = (columns, row, min) => {
  const ai = appsColIndex(columns);
  return !(min > 0 && ai >= 0) || (toNum(row[ai]) ?? 0) >= min;
};

// Competition ranking (ties share a rank) for key columns among qualified rows only, highest = #1.
export const keyRanks = (columns, rows, min = 0) => {
  const ok = rows.map((r) => qualifies(columns, r, min));
  const out = {};
  columns.forEach((c, ci) => {
    if (!isKey(c)) return;
    const vals = rows.map((r, i) => (ok[i] ? toNum(r[ci]) : null));
    const nums = vals.filter((v) => v !== null);
    if (nums.length) out[ci] = vals.map((v) => (v === null ? null : 1 + nums.filter((x) => x > v).length));
  });
  return out;
};

export const rankStyle = (rank, C) => {
  if (!rank || rank > 3) return null;
  return rank === 1
    ? { background: "rgba(212,175,55,0.26)", color: C.goldLight, fontWeight: 700 }
    : { background: "rgba(212,175,55,0.11)", color: C.gold, fontWeight: 600 };
};
